import {Pipe, Injectable, PipeTransform} from "@angular/core";
@Pipe({
  name: 'getPrice'
})
@Injectable()
export class PricePipe implements PipeTransform {
  transform(ingredient, sizeName: string){
    if (!sizeName || ingredient.prices.length === 0){
      return ingredient.price;
    }
    return ingredient.prices[sizeName.toLowerCase()];
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/getPrice.ts